import { BaseModel } from "./base.model";

export class RolModel extends BaseModel {
    public Id?: number;
    public Nombre: string;
    public Descripcion: string;
}